import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BACKEND_URL + '/api/notification';

class CartService {
    get(id) {
        return axios.get(API_URL + '/' + id, { headers: authHeader() });
    }

    store(data) {
        return axios.post(API_URL, data, { headers: authHeader() });
    }

    update(id, data) {
        return axios.post(API_URL + '/' + id + '?_method=PUT', data, { headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' } });
    }

    destroy(id) {
        return axios.delete(API_URL + '/' + id, { headers: authHeader() });
    }

    read(id, user_id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/read/notification';
        return axios.get(url + '/' + id + '/' + user_id, { headers: authHeader() });
    }

    getAllByUserId(user_id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getAllByUserId/notification';
        return axios.get(url + '/' + user_id, { headers: authHeader() });
    }

    readAllByUserId(user_id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/readAllByUserId/notification';
        return axios.get(url + '/' + user_id, { headers: authHeader() });
    }

    getNotificationCountByUserId(user_id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getNotificationCountByUserId/notification';
        return axios.get(url + '/' + user_id, { headers: authHeader() });
    }
}

export default new CartService();
